var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5653 14.565H1.61652C1.27602 14.565 1 14.289 1 13.9485V6.54913C1 6.20864 1.27602 5.93262 1.61652 5.93262H14.5653C14.9058 5.93262 15.1818 6.20864 15.1818 6.54913V13.9485C15.1818 14.289 14.9058 14.565 14.5653 14.565Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5653 14.5652H1.61652C1.27602 14.5652 1 14.2892 1 13.9487V2.76493C1 2.47127 1.23806 2.2332 1.53173 2.2332H2.233L2.23304 1.5317C2.23306 1.23805 2.47112 1 2.76477 1H5.36912C5.53262 1 5.68943 1.06495 5.80505 1.18057L6.67715 2.05264C6.79277 2.16825 6.94958 2.2332 7.11309 2.2332H14.5653C14.9058 2.2332 15.1818 2.50923 15.1818 2.84972V13.9487C15.1818 14.2892 14.9058 14.5652 14.5653 14.5652Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.6379 4.08301H2.53906V5.93281H13.6379V4.08301Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.e3d32ab6c347052716671df795877569.svg";
export { ForwardRef as ReactComponent };